import React from "react";
import { OtherPermissionsSectionProps } from "../types/types";
import { Form } from "@components";
import { Box } from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import { FORM_LABELS, MEXICO_OPTIONS, REGIONS } from "../constants/constants";

export const InsideSalesRepInfoSection: React.FC<OtherPermissionsSectionProps> = ({
  sectionNumber,
  form,
  onFormValueChange,
  language = "EN",
  region,
}) => {
  const LABELS = FORM_LABELS[language];

  return (
    <>
      <Form.Title>{`${sectionNumber} - ${LABELS.INSIDE_SALES_REP.FORM_TITLE}`}</Form.Title>
      <Form.Text color="warning.main">
        <Box display="flex">
          <WarningIcon />
          <Box pl={1} pt={0.5}>
            {LABELS.INSIDE_SALES_REP.FORM_NOTE}
          </Box>
        </Box>
      </Form.Text>
      <Form.Textbox
        label={LABELS.INSIDE_SALES_REP.FIRST_NAME}
        name="insideFirstName"
        onChange={onFormValueChange}
        size={6}
        value={form.values.insideFirstName}
      />
      <Form.Textbox
        label={LABELS.INSIDE_SALES_REP.REP_CODE_ISR}
        name="repCodeISR"
        onChange={onFormValueChange}
        size={6}
        value={form.values.repCodeISR}
      />
      <Form.Textbox
        label={LABELS.INSIDE_SALES_REP.LAST_NAME}
        name="insideLastName"
        onChange={onFormValueChange}
        size={6}
        value={form.values.insideLastName}
      />
      <Form.Textbox
        label={LABELS.INSIDE_SALES_REP.REP_CODE_USER}
        name="repCodeUser"
        onChange={onFormValueChange}
        size={6}
        value={form.values.repCodeUser}
      />
      <Form.Textbox
        label={LABELS.INSIDE_SALES_REP.PHONE_NUMBER}
        name="insidePhoneNumber"
        onChange={onFormValueChange}
        size={6}
        value={form.values.insidePhoneNumber}
      />
      {region === REGIONS.MEXICO ? (
        <Form.Dropdown
          options={MEXICO_OPTIONS.SALES_CHANNEL_UK}
          label={LABELS.INSIDE_SALES_REP.SALES_CHANNEL_UK}
          name="salesChannel"
          onChange={onFormValueChange}
          size={6}
          value={form.values.salesChannel}
        />
      ) : (
        <Form.Textbox
          label={LABELS.INSIDE_SALES_REP.SALES_CHANNEL_UK}
          name="salesChannel"
          onChange={onFormValueChange}
          size={6}
          value={form.values.salesChannel}
        />
      )}
      {region === REGIONS.MEXICO ? (
        <Form.Dropdown
          options={MEXICO_OPTIONS.MOSS_SALES_UNIT}
          label={LABELS.INSIDE_SALES_REP.MOSS_SALES_UNIT}
          name="mossSalesUnit"
          onChange={onFormValueChange}
          size={6}
          value={form.values.mossSalesUnit}
        />
      ) : (
        <Form.Textbox
          label={LABELS.INSIDE_SALES_REP.MOSS_SALES_UNIT}
          name="mossSalesUnit"
          onChange={onFormValueChange}
          size={6}
          value={form.values.mossSalesUnit}
        />
      )}
      {region === REGIONS.MEXICO ? (
        <Form.Dropdown
          options={MEXICO_OPTIONS.SALES_CHANNEL_CODE}
          label={LABELS.INSIDE_SALES_REP.SALES_CHANNEL_CODE}
          name="salesChannelCode"
          onChange={onFormValueChange}
          size={6}
          value={form.values.salesChannelCode}
        />
      ) : (
        <Form.Textbox
          label={LABELS.INSIDE_SALES_REP.SALES_CHANNEL_CODE}
          name="salesChannelCode"
          onChange={onFormValueChange}
          size={6}
          value={form.values.salesChannelCode}
        />
      )}
    </>
  );
};
